<div class="table-row">
  {{ 'noData' | translate }}
</div>
